/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import styled from 'styled-components';
import styles from '../../styles';
import Button from '../Button';

const Footer = styled.div`
  border-top: 2px solid ${styles.colors.geyser};
  border-bottom-right-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
  padding: 0.75rem 1rem;
  background-color: ${styles.colors.linkWater};
  text-align: right;

  ${Button} + ${Button} {
    margin-left: 1rem;
  }
`;

export default Footer;
